"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _geo = require("@nivo/geo");

var _countries = _interopRequireDefault(require("./geo/countries.json"));

require("./ChartLine.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ChartChoropleth extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getDomain", () => {
      let _this$props = this.props,
          domain = _this$props.domain,
          minimum = _this$props.minimum,
          maximum = _this$props.maximum;

      if (minimum && maximum) {
        domain = [0, maximum];
      }

      return domain;
    });

    _defineProperty(this, "getProps", () => {
      return _extends({}, this.props, {
        domain: this.getDomain()
      });
    });
  }

  render() {
    const props = this.getProps();
    return _react.default.createElement(_geo.ResponsiveChoropleth, props);
  }

}

_defineProperty(ChartChoropleth, "defaultProps", {
  data: [],
  features: _countries.default.features,
  colors: undefined,
  projectionScale: 100,
  projectionTranslation: [0.5, 0.5],
  projectionRotation: [0, 0, 0],
  enableGraticule: false,
  graticuleLineColor: "#dddddd",
  label: "properties.name",
  unknownColor: "#eeeeee",
  borderWidth: 0.25,
  borderColor: "#ffffff",
  domain: [0, 1000000],
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
});

var _default = ChartChoropleth;
exports.default = _default;
module.exports = exports.default;